import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LinkBar from "../../LinkBar/LinkBar";
import Search from "../Search/Search";

const Semesters = () => {
  const { series, dept, semester } = useParams();
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    dept &&
      semester &&
      fetch(`https://apichothaon1-hzrifat.b4a.run/subjects/${dept}${semester}`)
        .then((res) => res.json())
        .then((data) => setSubjects(data));
  }, [dept, semester]);

  return (
    <div className="container row">
      <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
        <Search />
      </div>
      <div className="col-md-8 col-sm-6 col-12">
        <LinkBar series={series} dept={dept} semester={semester} />
        <div className="row mt-5 mb-4 ">
          {subjects?.length
            ? subjects?.map((s, i) => {
                return (
                  <div
                    key={i}
                    className="col-md-3 col-sm-6 col-12 d-flex justify-content-center"
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      exact
                      to={`/collections/${series}/${dept}/${semester}/${s?.code?.toLowerCase()}${
                        s?.ext
                      }`}
                    >
                      <div className="folder-style">
                        <i
                          style={{ fontSize: "8rem" }}
                          className="fa-solid fa-folder"
                        ></i>
                        <p style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                          <span>
                            {s?.code}
                            {s?.ext}
                          </span>
                          <br />
                          <small>{s?.name}</small>
                        </p>
                      </div>
                    </Link>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default Semesters;
